import { FC } from 'react';
import { ChipProps } from '@material-ui/core';
import { WbComponentsListArray } from '../WbComponentsListArray';
import { Tag, TagKind, WbTag } from './WbTag';

type WbTagsArrayProps = ChipProps & {
  tags: Array<Tag>;
  kind?: TagKind;
  tooltip?: boolean;
  limit?: number;
  className?: string;
};

export const WbTagsArray: FC<WbTagsArrayProps> = ({
  tags,
  kind = TagKind.generic,
  tooltip = false,
  limit,
  className,
}: WbTagsArrayProps) => {
  const tagComponents = tags.map(t => (
    <WbTag
      style={{ width: 'fit-content', maxWidth: 'auto' }}
      key={t.tagFQN}
      tag={t}
      kind={kind}
      tooltip={tooltip}
    />
  ));
  return (
    <WbComponentsListArray
      className={className}
      children={tagComponents}
      limit={limit}
    />
  );
};
